import React from 'react';
import { s as styles } from '../image-viewer.rtlignore-0d751719.js';
import { ROOT } from '../dataHooks.js';
import '../style-inject.es-e7b07dd7.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ImageContainer = (props) => {
  const { type, disableDownload, children } = props;
  const hasOnClick = "onClick" in props;
  const onClick = hasOnClick ? props.onClick : void 0;
  const onKeyDown = onClick ? (e) => {
    if (e.key === "Enter" || e.key === " ") {
      onClick(e);
    }
  } : void 0;
  const interactions = {
    onClick,
    onKeyDown,
    onContextMenu: disableDownload
  };
  const role = hasOnClick || type === "regular" && !!disableDownload ? "button" : void 0;
  const tabIndex = role === "button" ? 0 : void 0;
  return /* @__PURE__ */ React.createElement(
    "figure",
    __spreadProps(__spreadValues({}, role === "button" ? interactions : {}), {
      role,
      "data-hook": ROOT,
      tabIndex,
      className: styles.imageContainer,
      "aria-haspopup": role === "button" ? true : void 0
    }),
    children
  );
};

export { ImageContainer };
//# sourceMappingURL=image-container.js.map
